export default {
  itemLayoutEditMode: false,
  hideFieldSelector: false,
  highlightedFieldName: '',
}
